import React from "react";

const ChartsLegend = React.memo(({ payload, legendItems }) => {
  return (
    <div
      dir="rtl"
      className="mt-3 flex flex-wrap items-center justify-center gap-x-5 gap-y-2"
    >
      {payload.map((entry, index) => (
        <div
          key={`item-${index}`}
          className="group inline-flex items-center gap-2 rounded-full px-2 py-0.5 transition-colors hover:bg-gray-50 dark:hover:bg-gray-800/60"
        >
          <span
            aria-hidden
            className="block h-2.5 w-2.5 rounded-full ring-2 ring-white shadow-sm transition-transform group-hover:scale-110 dark:ring-gray-800"
            style={{ backgroundColor: entry.color }}
          />
          <p className="m-0 text-xs font-medium tracking-tight text-gray-600 dark:text-gray-400">
            {legendItems[index].name}
          </p>
        </div>
      ))}
    </div>
  );
});

export default ChartsLegend;
